// extracted by mini-css-extract-plugin
export var messageSideLeft = "_l0-1";
export var messageSideRight = "_l0-2";
export var subscribeToBackInStockBubbleContainer = "_l0-0";